// Authenticated fetch wrapper — prefers Bearer token for Safari/iOS ITP compat, falls back to cookie.
// TODO(safari-itp): when same-domain, remove buildAuthHeaders + getStoredAccessToken and revert to cookie-only.
// On 401: refreshes token, then retries. Concurrent 401s deduplicated in refreshAccessToken.
// If refresh fails: triggers auth failure (logout + redirect to login) and throws.

import { refreshAccessToken, getStoredAccessToken } from '../auth/authService';
import { triggerAuthFailure } from '../auth/authHandlers';

function buildAuthHeaders(token: string | null): HeadersInit {
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function fetchWithAuth(url: string, options: RequestInit = {}): Promise<Response> {
  const token = getStoredAccessToken();
  const response = await fetch(url, {
    ...options,
    credentials: 'include',
    headers: { ...options.headers, ...buildAuthHeaders(token) },
  });

  if (response.status !== 401) return response;

  const newToken = await refreshAccessToken();
  if (!newToken) {
    triggerAuthFailure();
    throw {
      status: 401,
      code: 'CLIENT_SESSION_EXPIRED',
      message: 'Session expired. Please log in again.',
    };
  }

  return fetch(url, {
    ...options,
    credentials: 'include',
    headers: { ...options.headers, ...buildAuthHeaders(newToken) },
  });
}
